var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("TensorFlow.js Hello World")]),_c('b-button',{on:{"click":_vm.predict}},[_vm._v("predict")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }